import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

// Helper function to detect videos based on file extensions
const isVideoFile = (fileUrl) => {
  return /\.(mp4|mov|avi|mkv|webm)$/i.test(fileUrl);
};

const MediaPreviewDialog = ({ open, onClose, mediaItems }) => {
  // Manage the internal open state
  const [isOpen, setIsOpen] = useState(false);

  // Sync the internal state with the `open` prop from the parent
  useEffect(() => {
    if (open) {
      setIsOpen(open);
    }
  }, [open]);

  const handleClose = () => {
    setIsOpen(false);
    onClose(); // Notify the parent that the dialog is closing
  };

  // Format media items for ReactImageGallery
  const galleryItems = mediaItems?.map((media) => {
    if (isVideoFile(media.url)) {
      // Handle video
      return {
        original: media.url,
        thumbnail: media.thumbnail || "https://via.placeholder.com/150",
        embedUrl: media.url,
        renderItem: () => (
          <video
            controls
            style={{ width: "100%", maxHeight: "400px", objectFit: "contain" }}
          >
            <source
              src={media.url}
              type={`video/${media.url.split(".").pop()}`}
            />
            Your browser does not support the video tag.
          </video>
        ),
      };
    } else {
      // Handle image
      return {
        original: media.url,
        thumbnail: media.url,
      };
    }
  });

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      // disableEscapeKeyDown={true} // Prevent closing with Esc key
      // onBackdropClick={(e) => e.stopPropagation()} // Prevent closing on outside click
    >
      <DialogContent>
        {/* Close Button */}
        <IconButton
          sx={{ position: "absolute", top: 8, right: 8 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>

        {/* React Image Gallery */}
        <ReactImageGallery
          items={galleryItems || []}
          showThumbnails={true}
          showFullscreenButton={true}
          showPlayButton={false}
          startIndex={0}
        />
      </DialogContent>
    </Dialog>
  );
};

export default MediaPreviewDialog;
